module.exports = __webpack_public_path__ + "assets/img/1611.f75b06d4.png";